import { Option } from "../../../util/option";

export type AddCmpProjectDialogState = {
  projectType: string;
  dipByRegion: string;
  rootComponentId: string;
  componentId: string;
  protocol: string;
  changeTarget: string[];
  partner: string;
  projectTypeList: Option[];
  dipByRegionList: Option[];
  componentIdMap: Map<string, RootCmp[]>;
  filteredComponentIdList: Option[];
  partnerList: Option[];
  protocolMap: Map<string, Option[]>;
  filteredProtocolList: Option[];
  changeTargetOption: Option[];
  isShow: boolean;
  isEdited: boolean;
  fieldPath: {
    cpntPjtTypeCd: string;
    dipByRgn: string;
    cpntId: string;
    ptnrId: string;
    prtclTypeCd: string;
    changeAttributeFlg: string;
  };
};
export type RootCmp = {
  rootCmpId: string;
  cmpIdOption: Option[];
};
export type PageNewState =
  | AddCmpProjectDialogState
  | ((prevState: AddCmpProjectDialogState) => AddCmpProjectDialogState);
